import { Http } from "@Services";
import {
    CreatePollRequest,
    CreatePollResponse,
    SubmitVoteRequest,
    CreateCommentRequest,
    CreateCommentResponse,
    GetPollCommentsResponse,
    UpdateVoteRequest,
    UpdateVoteChoiceRequest,
    UpdatePollRequest,
} from "./interfaces";
import { formatVotingResponse } from "./parsers";

export const putLikePoll = async (poll_id: string): Promise<any> => {
    let response: any;
    try {
        response = await Http.Request<CreateCommentResponse>({
            method: "PUT",
            url: `polls/${poll_id}/like`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }
    return response;
};

export const updateComment = async (
    poll_id: string,
    comment_id: string,
    data: CreateCommentRequest
): Promise<CreateCommentResponse> => {
    let response: CreateCommentResponse;

    try {
        response = await Http.Request<CreateCommentResponse>({
            method: "PUT",
            url: `/polls/${poll_id}/comments/${comment_id}`,
            data,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};

export const postdeleteComment = async (
    poll_id: string,
    comment_id: string
): Promise<void> => {
    try {
        await Http.Request<any>({
            method: "DELETE",
            url: `/polls/${poll_id}/comments/${comment_id}`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error);
    }
};

export const createComment = async (
    pollId: string,
    data: CreateCommentRequest
): Promise<CreateCommentResponse> => {
    let response: CreateCommentResponse;

    try {
        response = await Http.Request<CreateCommentResponse>({
            method: "POST",
            url: `/polls/${pollId}/comments`,
            data,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};

export const getPollComments = async (
    poll_id: string,
    skip = 0,
    limit = 10
): Promise<GetPollCommentsResponse> => {
    let response: GetPollCommentsResponse;
    try {
        response = await Http.Request<GetPollCommentsResponse>({
            method: "GET",
            url: `/polls/${poll_id}/comments?limit=${limit}&skip=${skip}&order=desc`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }
    return response;
};

export const postPollCreation = async (
    data: CreatePollRequest
): Promise<any> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "POST",
            url: "/polls",
            data,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};

export const updatePoll = async (
    poll_id: string,
    data: UpdatePollRequest
): Promise<any> => {
    let response: any;

    try {
        response = await Http.Request<any>({
            method: "PUT",
            url: `/polls/${poll_id}`,
            data,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};

export const submitVote = async (
    poll_id: string,
    data: SubmitVoteRequest
): Promise<CreatePollResponse> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "POST",
            url: `/polls/${poll_id}/vote`,
            data,
        });
    } catch (error) {
        throw error;
    }

    return formatVotingResponse(response);
};

export const submitAnonymousvote = async (
    poll_id: string,
    data: SubmitVoteRequest
): Promise<CreatePollResponse> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "POST",
            url: `/polls/${poll_id}/bulk-vote`,
            data,
        });
    } catch (error) {
        throw error;
    }

    return formatVotingResponse(response);
};

export const replaceAnonymousVote = async (
    poll_id: string,
    data: UpdateVoteChoiceRequest
): Promise<CreatePollResponse> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "PUT",
            url: `/polls/${poll_id}/bulk-vote`,
            data,
        });
    } catch (error) {
        throw error;
    }

    return formatVotingResponse(response);
};

export const updateAnonymousVote = async (
    poll_id: string,
    data: UpdateVoteRequest
): Promise<any> => {
    try {
        await Http.Request<UpdateVoteRequest>({
            method: "PATCH",
            url: `/polls/${poll_id}/bulk-vote`,
            data,
        });
    } catch (error) {
        throw error;
    }
};

export const deleteVote = async (
    poll_id: string
): Promise<CreatePollResponse> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "DELETE",
            url: `/polls/${poll_id}/vote`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return formatVotingResponse(response);
};

export const deleteAnonymousVote = async (
    poll_id: string
): Promise<CreatePollResponse> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "DELETE",
            url: `/polls/${poll_id}/bulk-vote`,
        });
    } catch (error) {
        throw error;
    }

    return formatVotingResponse(response);
};

//@todo refactor this returns something
export const postDeletePoll = async (poll_id: string): Promise<void> => {
    try {
        await Http.Request<any>({
            method: "DELETE",
            url: `/polls/${poll_id}`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error);
    }
};

export const updateClosePoll = async (poll_id: string): Promise<void> => {
    try {
        await Http.Request<any>({
            method: "PATCH",
            url: `/polls/${poll_id}`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error);
    }
};

export const getSinglePoll = async (poll_id: string): Promise<any> => {
    let response: CreatePollResponse;

    try {
        response = await Http.Request<CreatePollResponse>({
            method: "GET",
            url: `/polls/${poll_id}`,
        });
    } catch (error) {
        // @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};
